<div class="custom-select">
    <ng-content></ng-content>
    <svg class="select-arrow" *ngIf="!isNotdropDown">
        <use xlink:href="#down-arrow"></use>
    </svg>
</div>
